module.exports = __webpack_public_path__ + "static/img/7.ad6c231.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/7.png
// module id = 7Thk
// module chunks = 0